import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Link from "./link"

function FocusGradientAccelerator(): JSX.Element {
  const image: Queries.SmallAcceleratorImageQuery = useStaticQuery(graphql`
    query SmallAcceleratorImage {
      lg: file(relativePath: { eq: "Blog-Banner.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
      xs: file(relativePath: { eq: "Blog-Square-Ad.jpg" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `)
  return (
    <section className="alignfull border-none relative overflow-hidden h-[350px]">
      <img
        className="absolute h-[350px] w-full object-cover "
        src={image?.xs?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
        // src='https://static.georgiancollege.ca//static/20105fc11b13b963a3541c6cea2370f9/05601/Blog-Square-Ad.jpg'
        alt="Sign up for Georgian updates!"
      />
      <div
        className="h-[350px] w-full absolute z-99"
        style={{
          background: `linear-gradient(29deg, rgba(0,75,135,1) 0%, rgba(0,75,135,1) calc((100% - 1170px) / 2), rgba(0,75,135,0) calc(((100% - 1170px) / 2) + 585px), rgba(81,131,14,0) calc(((100% - 1170px) / 2) + 875px), rgba(81,131,14,1) calc(100% - ((100% - 1170px) / 2)), rgba(81,131,14,1) 100%)`,
        }}
      ></div>
      <div className="px-8">
        <div className="flex flex-col items-start justify-center h-[350px] w-2/3 mr-auto ml-0 relative overflow-hidden">
          <h1 className="text-2xl  font-normal  text-white mb-4 overflow-auto">
            Sign up for Georgian updates!
          </h1>
          <p className="text-white font-normal text-sm leading-6 overflow-auto">
            Subscribe to{` `}
            <strong className="font-bold italic overflow-auto">The ACCELERATOR</strong>
            {` `}
            &mdash; the Georgian College monthly newsletter.
          </p>
          <Link
            to="/about-georgian/contact-us/mailing-list/"
            className="bg-teal-vivid text-white text-lg px-8 py-4 hover:vivid-gradient overflow-auto"
          >
            Subscribe
          </Link>
        </div>
      </div>
    </section>
  )
}

export default FocusGradientAccelerator
